import {
  InfoIconTooltip,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@ais-ui/ui-core';
import { useLocalization } from '@ais-ui/locale-management';
import { UseFormReturn } from 'react-hook-form';
import { PrefilledField, PrefilledFieldsMap } from '../../reportsTypes';

interface ProfileSelectProps {
  prefilledFieldsMap: PrefilledFieldsMap;
  form: UseFormReturn<any>;
  prefix?: string;
}

export const ProfileSelect = ({
  prefilledFieldsMap,
  form,
  prefix = 'miscellaneous.',
}: ProfileSelectProps) => {
  const { messages } = useLocalization();

  const onSelect = (value: string) => {
    const prefillObject = prefilledFieldsMap[value];
    prefillObject.fields.forEach((field: PrefilledField) => {
      const fieldPath = prefix
        ? `${prefix}${field.fieldName}`
        : field.fieldName;
      form.setValue(fieldPath, field.fieldValue);
    });
  };

  return (
    <div className="mb-6 space-y-2">
      <div className="flex justify-between">
        <Label>
          {messages.reportsCreateReportMiscellaneousPrefillValuesLabel}
        </Label>
        <InfoIconTooltip className="mr-2">
          {messages.reportsCreateReportMiscellaneousPrefillValuesTooltip}
        </InfoIconTooltip>
      </div>
      <Select onValueChange={onSelect}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select profile" />
        </SelectTrigger>

        <SelectContent>
          {Object.entries(prefilledFieldsMap).map(([key, prefillObject]) => (
            <SelectItem key={key} value={key}>
              {prefillObject.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
